<h2 mat-dialog-title>{{ title }}</h2>
<mat-dialog-content class="overtime-resolution-dialog">
  <p>{{ description }}</p>

  @if (mode === 'approve') {
  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
    <mat-label>{{ 'overtimesCatalog.dialog.approvedMinutes' | translate }}</mat-label>
    <input matInput type="number" min="0" [formControl]="approvedMinutesControl">
  </mat-form-field>
  }

  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
    <mat-label>{{ 'overtimesCatalog.dialog.comment' | translate }}</mat-label>
    <textarea matInput rows="3" [formControl]="commentControl"></textarea>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button type="button" [mat-dialog-close]="null">{{ 'common.cancel' | translate }}</button>
  <button mat-flat-button color="primary" type="button" [disabled]="mode === 'approve' && approvedMinutesControl.invalid" (click)="submit()">
    {{ confirmLabel }}
  </button>
</mat-dialog-actions>
